import api from "@/config/axios";

const path = "ticket/";

export default {
  cargarTickets(tipo_consulta) {
    return api.get(path + `userTickets/${tipo_consulta}`);
  },
  contadorTickets(tipo_consulta) {
    return api.get(path + `countTickets/${tipo_consulta}`);
  },
  ticketQA() {
    return api.get(path + `getUserTicketsQA`);
  },
  cargarTicketsFiltrados(params) {
    return api.get(path + `filterTickets`, {
      params,
    });
  },
  getSeleccionables(accion, params) {
    if (params)
      return api.get(path + `ticketSelects/${accion}`, {
        params,
      });
    else return api.get(path + `ticketSelects/${accion}`);
  },
  getEstadoQA(form) {
    return api.get(
      path + `ticketStates/${form.id_ticket}/${form.tipo_consulta}`
    );
  },
  getHistorico(id_ticket) {
    return api.get(path + `ticketComments/${id_ticket}`);
  },
  getArchivos(id_ticket, id_doc) {
    if (!id_doc) return api.get(path + `ticketFiles/${id_ticket}`);
    else return api.get(path + `ticketFiles/${id_ticket}/${id_doc}`);
  },

  solicitarTicket(form) {
    return api.post(path + "createTicket", form);
  },
  guardarQA(form) {
    return api.put(path + "updateTicket", form);
  },
  updateMultiple(form) {
    return api.put(path + "updateTicketMultiple", form);
  },
  subirArchivo(form) {
    return api.post(path + "uploadTicketFile", form);
  },
};
